import { render, staticRenderFns } from "./ConsultantCreateUpdate.vue?vue&type=template&id=780c40aa&"
import script from "./ConsultantCreateUpdate.vue?vue&type=script&lang=js&"
export * from "./ConsultantCreateUpdate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports